import React, { useState } from "react";

const EVM_NETWORKS = [
  "Ethereum (ERC20)", "Polygon", "BNB Smart Chain (BEP20)",
  "Arbitrum One", "Optimism", "AVAX C-Chain", "opBNB", "CELO", "KAVAEVM",
];

// Truncates 0xb37DaF...2AE8 for display
const shortAddr = (addr) =>
  addr ? `${addr.slice(0, 6)}...${addr.slice(-4)}` : "";

export default function WalletAccess({ address }) {
  const [copied, setCopied] = useState(false);

  const copyAddress = () => {
    navigator.clipboard.writeText(address);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="wallet-access-card">
      <div className="wallet-access-header">
        <span className="eyebrow">Mi Wallet · EVM</span>
      </div>

      <div className="wallet-address-box" style={{ margin: "12px 0" }}>
        <span className="wallet-address-text">{address}</span>
        <button className="btn btn-primary wallet-copy-btn" onClick={copyAddress}>
          {copied ? "¡Copiado!" : "Copiar"}
        </button>
      </div>

      {/* Explorer links — one per chain so user can check any balance */}
      <div className="wallet-explorers">
        <p className="wallet-networks-label">Ver balance en:</p>
        <div className="wallet-networks-list" style={{ gap: "15px", display: "flex", flexWrap: "wrap", }}>
          <a href={`https://polygonscan.com/address/${address}`} target="_blank" rel="noreferrer" className="wallet-explorer-link">Polygon</a>
          <a href={`https://etherscan.io/address/${address}`} target="_blank" rel="noreferrer" className="wallet-explorer-link">Ethereum</a>
          <a href={`https://bscscan.com/address/${address}`} target="_blank" rel="noreferrer" className="wallet-explorer-link">BNB Chain</a>
          <a href={`https://arbiscan.io/address/${address}`} target="_blank" rel="noreferrer" className="wallet-explorer-link">Arbitrum</a>
          <a href={`https://optimistic.etherscan.io/address/${address}`} target="_blank" rel="noreferrer" className="wallet-explorer-link">Optimism</a>
        </div>
      </div>

      <div className="wallet-networks" style={{ marginTop: 14 }}>
        <p className="wallet-networks-label">✅ Compatible con estas redes en CryptoPocket:</p>
        <div className="wallet-networks-list" style={{ display: "flex", flexWrap: "Wrap", gap: "5px" }}>
          {EVM_NETWORKS.map((n, i) => (
            <span key={n} className="wallet-network-tag">{n} {i !== 8 ? "," : ""}</span>
          ))}
        </div>
      </div>
    </div>
  );
}